import { createSelector } from 'reselect';

const selectEmployees = (state) => state.employees;

export const selectEmployeesById = createSelector(
  [selectEmployees],
  (employees) => employees.itemsById
);
